__turbopack_context__.v({
  "frame": "IFrame-module__HYEgOa__frame",
  "placeholder": "IFrame-module__HYEgOa__placeholder",
  "placeholderImage": "IFrame-module__HYEgOa__placeholderImage",
  "root": "IFrame-module__HYEgOa__root",
});
